import React from 'react';

import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import Label from 'components/Label';

import { StyledSelect, MenuContainer, ItemTitle, ItemSubtitle } from './styles';

function Select({
  label,
  labelColor,
  name,
  placeholder,
  options = [],
  itemTitle = 'label',
  itemValue = 'value',
  itemSubtitle,
  companySelector,
  textColor,
  value,
  testId,
  ...rest
}) {
  const handledValue = value || 'placeholder';

  return (
    <>
      {label && (
        <Label
          htmlFor={name}
          className="textLabel"
          uppercase
          style={labelColor ? { color: labelColor } : undefined}
        >
          {label}
        </Label>
      )}
      <StyledSelect
        input={<OutlinedInput name={name} id={name} />}
        value={handledValue}
        $textColor={textColor}
        {...rest}
      >
        {placeholder && (
          <MenuItem disabled value="placeholder">
            <MenuContainer>
              <ItemTitle noUnderline companySelector={companySelector} $textColor={textColor}>
                {placeholder}
              </ItemTitle>
            </MenuContainer>
          </MenuItem>
        )}
        {options.map((option, index) => (
          <MenuItem key={index} value={option[itemValue]} id={testId}>
            <MenuContainer>
              <ItemTitle companySelector={companySelector} $textColor={textColor}>
                {option[itemTitle]}
              </ItemTitle>
              {itemSubtitle && <ItemSubtitle $textColor={textColor}>{option[itemSubtitle]}</ItemSubtitle>}
            </MenuContainer>
          </MenuItem>
        ))}
      </StyledSelect>
    </>
  );
}

export default Select;
